(function () {
    var tocEl = document.querySelector('.gh-toc');
    if (!tocEl || typeof tocbot === 'undefined') return;

    var headings = document.querySelectorAll('.gh-content h2, .gh-content h3');
    if (headings.length < 2) {
        var wrapper = document.querySelector('.gh-toc-wrapper');
        if (wrapper) wrapper.style.display = 'none';
        return;
    }

    tocbot.init({
        tocSelector: '.gh-toc',
        contentSelector: '.gh-content',
        headingSelector: 'h2, h3',
        hasInnerContainers: true,
        scrollSmooth: false,
        headingsOffset: 80,
        scrollSmoothOffset: -20,
        orderedList: false
    });

    var toggle = document.querySelector('.gh-toc-toggle');
    if (toggle) {
        toggle.addEventListener('click', function () {
            var wrapper = document.querySelector('.gh-toc-wrapper');
            if (wrapper) wrapper.classList.toggle('is-expanded');
        });
    }
})();
